import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import useAxios from '../../Hooks/useAxios';


 let activeProcesses = [];

const ActiveProcess = () => {

};


//$$ Getting process from api
const useActiveProcesses = () => {

    const { data } = useAxios("processes");

    const [activeProcesses, setActiveProcesses] = React.useState([]);

    React.useEffect(() => {

        if (data && Array.isArray(data)) {

            setActiveProcesses(
                data
                    .filter(row => row.statusId !== 3)
                    .map(row => row.id)
            );
        }

    }, [data]);

    return activeProcesses;
};

//$$ exporting Active processes array to others cards components

export default ActiveProcess;

export { useActiveProcesses };

